export default "__VITE_ASSET__DuNKv$sE__"